import { render, staticRenderFns } from "./usersAdd.vue?vue&type=template&id=22254265&scoped=true&"
import script from "./usersAdd.vue?vue&type=script&lang=js&"
export * from "./usersAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22254265",
  null
  
)

export default component.exports